export const environment = {
    production: false,
    version: '1.0.0',
    type: 'develop',
    api: {
        url: 'https://dev.evolution.bravobit.nl/api'
    },
    mockPlatformId: '38' // "Enzo knol" platform.
};
